/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable import/order */

import axios from 'axios';
import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import Link from '@material-ui/core/Link';
import AddRoundedIcon from '@material-ui/icons/AddRounded';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {
  encrypt,
  apiList,
  addCommas,
  shortDate,
  shortData,
  verifyLogin,
} from '../../helpers';
import DataTable from '../../components/DataTable/DataTable';
import { RowAction, RowActions } from '../../components/RowActions/RowActions';

const columns = [
  {
    id: 'Id', label: 'Id', fieldName: 'id',
  },
  {
    id: 'name', label: 'Customer Name', fieldName: 'custName',
  },
  {
    id: 'branchName', label: 'Branch Code', fieldName: 'branchName',
  },
  {
    id: 'LoanNumber',
    label: 'Loan Number',
    fieldName: 'loanNumber',
  },
  {
    id: 'SanctionedAmount',
    label: 'Sanctioned Amount',
    fieldName: 'sanctionedAmount',
  },
  {
    id: 'SanctionedDate',
    label: 'Sanctioned Date',
    fieldName: 'sanctionedDate',
  },
  {
    id: 'action',
    label: 'Action',
  },
];

const useStyles = () => ({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  tablewo: {
    cursor: 'pointer',
    '&:hover': {
      background: '#eeeeee',
    },
  },
  mainContainer: {
    // The page container (components/PageContainer) owns padding and width.
    width: '100%',
    minWidth: 0,
  },
  tableWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'stretch',
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    margin: 20,
  },
  buttonLink: {
    width: 20,
    height: 20,
    margin: 0,
    padding: 10,
  },
});

const PAGE_SIZE = 25;

class table extends Component {
  constructor() {
    super();
    this.state = {
      page: 1,
      rowsPerPage: PAGE_SIZE,
      result: false,
      pageCount: 0,
      totalCount: 0,
      data: [],
      searchQuery: '',
    };
  }

  componentDidMount() {
    this.getCustomer(this.state.page, this.state.rowsPerPage, this.state.searchQuery);
  }

  getViewLoanUrl(viewId) {
    const detailId = encrypt(viewId);
    return `/view-loan-details/${detailId}`;
  }

  handleChangePage = (event, newPage) => {
    this.getCustomer(newPage, this.state.rowsPerPage, this.state.searchQuery);
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (size) => {
    this.setState({ rowsPerPage: size, page: 1 });
    this.getCustomer(1, size, this.state.searchQuery);
  };

  // A new search starts from page 1.
  handleChange = (event) => {
    this.setState({ searchQuery: event.target.value, page: 1 });
    this.getCustomer(1, this.state.rowsPerPage, event.target.value);
  };

  getLoans() {
    this.setState({
      rowsPerPage: PAGE_SIZE, page: 1, data: [], searchQuery: '',
    });
    this.getCustomer(1, PAGE_SIZE, '');
  }

  getCustomer(page, rowsPerPage, searchQuery) {
    // Only the latest request may update the table: an older, slower reply
    // (e.g. for "a" while the user has typed "aug") is ignored.
    this.requestSeq = (this.requestSeq || 0) + 1;
    const seq = this.requestSeq;
    this.setState({ result: true });
    const { session } = verifyLogin();
    const config = { headers: { session, permissionConfig: 'Loan', feature: 'view' } };

    axios.get(`${apiList.VEIW_CUSTOMERS_API}?searchQuery=${encodeURIComponent(searchQuery)}&page=${page}&limit=${rowsPerPage}`, config)
      .then((response) => {
        if (seq !== this.requestSeq) return;
        this.setState({
          data: [...response.data.data.paginate],
          pageCount: Math.ceil(response.data.data.pageCount),
          totalCount: response.data.data.totalCount || 0,
          result: false,
        });
      })
      .catch((error) => {
        if (seq !== this.requestSeq) return;
        console.log(error);
        this.setState({
          data: [],
          pageCount: 0,
          totalCount: 0,
          result: false,
        });
        // toast.error(`${error.response.data.error || error.response.data.message}`);
      });
  }

  render() {
    const {
      classes, handleShowEditForm, handleDeleteData, permission, onAdd,
    } = this.props;
    const {
      result,
      data,
      page,
      pageCount,
      totalCount,
      rowsPerPage,
      searchQuery,
    } = this.state;

    return (
      <div className={classes.mainContainer}>

        <ToastContainer />

        <div className={classes.tableWrap}>
          <DataTable
            flush
            loading={result}
            title='Loans'
            search={{ placeholder: 'Search loans', value: searchQuery, onChange: this.handleChange }}
            actions={[onAdd && { name: 'Add Loan', icon: AddRoundedIcon, onClick: onAdd }]}
            tableHead={columns}
            itemComponent={data.length > 0 ? data.map((element, index) => (

              <TableRow
                className={classes.tablewo}
                tabIndex={-1}
                key={element.id}
              >
                <TableCell> {(page - 1) * rowsPerPage + index + 1}</TableCell>
                <TableCell>
                  <Link
                    underline='always'
                    href={this.getViewLoanUrl(element.id)}
                  >{shortData(element.custName)}
                  </Link>
                </TableCell>
                <TableCell> {element?.branch || element?.AccessLevelConfig?.branchName || 'N/A'}</TableCell>
                <TableCell> {shortData(element.loanNumber)}</TableCell>
                <TableCell> {addCommas(element.sanctionedAmount)}</TableCell>
                <TableCell> {shortDate(element.sanctionedDate)}</TableCell>
                <TableCell>
                  <RowActions>
                    <RowAction
                      kind='edit'
                      disabled={!permission.edit}
                      onClick={() => { handleShowEditForm && handleShowEditForm(element); }}
                    />
                    <RowAction
                      kind='delete'
                      disabled={!permission.delete}
                      onClick={() => { handleDeleteData && handleDeleteData(element.id); }}
                    />
                  </RowActions>
                </TableCell>
              </TableRow>

            )) : null}
            serverSide
            count={pageCount}
            page={page}
            handleChangePage={this.handleChangePage}
            totalCount={totalCount}
            pageSize={rowsPerPage}
            onPageSizeChange={this.handleChangeRowsPerPage}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(table);
